import { render, staticRenderFns } from "./hz-record.vue?vue&type=template&id=46d2fa64&scoped=true&"
import script from "./hz-record.vue?vue&type=script&lang=js&"
export * from "./hz-record.vue?vue&type=script&lang=js&"
import style0 from "./hz-record.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./hz-record.vue?vue&type=style&index=1&id=46d2fa64&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d2fa64",
  null
  
)

export default component.exports